import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  menuContext: false,
  points: { x: 0, y: 0 },
  job: {},
  clickedFromLocTab: false,
  editBookingContext: false,
  accordionCache: [],
  paxCheckInModal: false,               // open or close passenger check in modal 
  //passenger
  paxLocation: false,
  passengerMenupoints: { x: 0, y: 0 },
  passenger: {},
  paxContextMenuModal: false,

  // delete Booking Modal
  showDeleteBookingModal: false,

  // show the flight list
  showFlightList: false,

  flightContext: false,
  flightContextPoints: { x: 0, y: 0 },
  selectedFlightForContext: null,

  changeLocModal: {
    show: false,
    passenger: {}
  },


}

const MenuContextSlice = createSlice({
  name: 'menuContext',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setPoints: (state, action) => {
      state.points = action.payload;
    },
    setClicked: (state, action) => {
      state.menuContext = action.payload;
    },
    setClickedJob: (state, action) => {
      state.job = action.payload;
    },
    setClickedFromLocTab: (state, action) => {
      state.clickedFromLocTab = action.payload;
    },
    setEditBookingContext: (state, action) => {
      state.editBookingContext = action.payload;
    },
    resetMenuContext: (state) => {
      state.menuContext = false;
      state.points = { x: 0, y: 0 };
      state.editBookingContext = false;
      state.clickedFromLocTab = false;
    },
    setAccordionCache: (state, action) => {
      state.accordionCache = action.payload;
    },
    openPaxCheckInModal: (state, action) => {
      state.paxCheckInModal = action.payload;
    },
    setPaxLocation: (state, action) => {
      state.paxLocation = action.payload;
    },
    openPaxContextMenuModal: (state, action) => {
      state.paxContextMenuModal = action.payload;
    },
    setPaxMenuContext: (state, action) => {
      state.passengerMenupoints = action.payload.locationPoints;
      state.passenger = action.payload.passenger;
    },
    setShowDeleteBookingModal: (state, action) => {
      state.showDeleteBookingModal = action.payload;
    },
    setShowFlightList: (state, action) => {
      state.showFlightList = action.payload;
    },

    showFlightContext: (state, action) => {
      state.flightContext = action.payload;
    },
    setFlightContextPoints: (state, action) => {
      state.flightContextPoints = action.payload;
    },

    setSelectedFlightForContext: (state, action) => {
      state.selectedFlightForContext = action.payload;
    },

    resetFlightContext: (state) => {
      state.flightContext = false;
      state.flightContextPoints = { x: 0, y: 0 };
      state.selectedFlightForContext = null;
    },
    setChangeLocModal: (state, action) => {
      state.changeLocModal.passenger = action.payload.passenger || {};
      state.changeLocModal.show = action.payload.show ?? false;
    }

  },
});

export default MenuContextSlice.reducer;

export const selectMenuContext = (state) => state.menuContext.menuContext;
export const selectMenuPoints = (state) => state.menuContext.points;
export const selectJob = (state) => state.menuContext.job;
export const selectClickedFromLocTab = (state) => state.menuContext.clickedFromLocTab;
export const selectEditBookingContext = (state) => state.menuContext.editBookingContext;
export const selectPaxCheckInModal = (state) => state.menuContext.paxCheckInModal;
export const selectPaxLocation = (state) => state.menuContext.paxLocation;

export const selectAccordionCache = (state) => state.menuContext.accordionCache;
export const selectPaxMenuContext = (state) => state.menuContext.passenger;
export const selectPaxMenuContextModal = (state) => state.menuContext.paxContextMenuModal;
export const selectPaxMenuLocationPoints = (state) => state.menuContext.passengerMenupoints;
export const selectShowDeleteBookingModal = (state) => state.menuContext.showDeleteBookingModal;
export const selectShowFlightList = (state) => state.menuContext.showFlightList;

export const selectFlightContext = (state) => state.menuContext.flightContext;
export const selectFlightContextPoints = (state) => state.menuContext.flightContextPoints;
export const selectSelectedFlightForContext = (state) => state.menuContext.selectedFlightForContext;
export const selectChangeLocModal = state => state.menuContext.changeLocModal


export const { setPoints, setClicked, setClickedJob, resetMenuContext, setEditBookingContext, setAccordionCache, openPaxCheckInModal, setPaxLocation, setPaxMenuContext, openPaxContextMenuModal, reset, setShowDeleteBookingModal, setShowFlightList, showFlightContext, setFlightContextPoints, setSelectedFlightForContext, resetFlightContext, setClickedFromLocTab, setChangeLocModal } = MenuContextSlice.actions;
